export default __webpack_public_path__ + "static/media/one-on-one.24293cbb.svg";